export const TOTAL_GROSS_PROCEEDS = {
  prefix: "$",
  value: 79579.39,
  suffix: "",
  change: 0,
  changeSuffix: "",
  decimals: 0,
};
